import styles from './BrandLogo.module.css';

type BrandLogoProps = {
  size?: number;
  className?: string;
};

export function BrandLogo({ size = 30, className }: BrandLogoProps) {
  return (
    <img
      src="/logo.png"
      alt=""
      className={className ? `${styles.mark} ${className}` : styles.mark}
      width={size}
      height={size}
      decoding="async"
    />
  );
}
